<div>
  <h1 style="display:flex; gap:8px;">
    <div style="padding-top: 4px;">
      <mat-icon color="warn">{{ confirmData.icon }}</mat-icon>
    </div>
    <div>
      {{ confirmData.title }}
    </div>
    <div style="flex:1"></div>
    <div>
      <button mat-icon-button mat-dialog-close>
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </h1>
</div>

<div class="inset" style="padding-bottom: 16px;">

  <mat-dialog-content class="mat-typography">
    <div>
      <div *ngIf="hasImage" style="padding-top: 52px;">
        <h3>{{ confirmData.message }}</h3>
      </div>
      <div *ngIf="!hasImage">
        <h3>{{ confirmData.message }}</h3>
      </div>
      <div fxFlex="50" *ngIf="hasImage" style="margin-right: 8px;">
        <img [src]="confirmData.image" width="320">
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions style="display:flex">
    <div style="flex:1"></div>
    <button mat-stroked-button mat-dialog-close class="btn" *ngIf="confirmData.cancel" (click)="oncancel()">
      {{confirmData.cancel}}
    </button>
    <button mat-flat-button [mat-dialog-close]="true" class="btn" cdkFocusInitial color="primary"(click)="submit()">
      {{ confirmData.confirm }}
    </button>
  </mat-dialog-actions>

</div>